import {Box, Heading} from '@salesforce/retail-react-app/app/components/shared/ui';

export function ChooseYourSets() {
  return (
    <Box borderColor="gray.200" borderRadius="md" borderWidth={1} padding={4}>
      <Heading as="h4">Choose Your Sets</Heading>
    </Box>
  );
}
